module.exports = __webpack_public_path__ + "img/welfare_btn_get.cc78b426.png";